/**
 * @generated SignedSource<<7f0800ca891680dd65396883524e54bc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeletePersonalizedEmailTemplateInput = {
  clientMutationId?: string | null | undefined;
  ids: ReadonlyArray<string>;
};
export type EmailTemplatesTable_DeleteMutation$variables = {
  connections: ReadonlyArray<string>;
  input: DeletePersonalizedEmailTemplateInput;
};
export type EmailTemplatesTable_DeleteMutation$data = {
  readonly Admin: {
    readonly Email: {
      readonly deletePersonalizedEmailTemplate: {
        readonly deletedIds: ReadonlyArray<string>;
      } | null | undefined;
    };
  };
};
export type EmailTemplatesTable_DeleteMutation = {
  response: EmailTemplatesTable_DeleteMutation$data;
  variables: EmailTemplatesTable_DeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedIds",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "EmailTemplatesTable_DeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "EmailAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Email",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "DeletePersonalizedEmailTemplatePayload",
                "kind": "LinkedField",
                "name": "deletePersonalizedEmailTemplate",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "EmailTemplatesTable_DeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "EmailAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Email",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "DeletePersonalizedEmailTemplatePayload",
                "kind": "LinkedField",
                "name": "deletePersonalizedEmailTemplate",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "filters": null,
                    "handle": "deleteEdge",
                    "key": "",
                    "kind": "ScalarHandle",
                    "name": "deletedIds",
                    "handleArgs": [
                      {
                        "kind": "Variable",
                        "name": "connections",
                        "variableName": "connections"
                      }
                    ]
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0c269726ded28bd7244df147bded35c7",
    "id": null,
    "metadata": {},
    "name": "EmailTemplatesTable_DeleteMutation",
    "operationKind": "mutation",
    "text": "mutation EmailTemplatesTable_DeleteMutation(\n  $input: DeletePersonalizedEmailTemplateInput!\n) {\n  Admin {\n    Email {\n      deletePersonalizedEmailTemplate(input: $input) {\n        deletedIds\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "55e41ab48feca93395b719f5ce149de7";

export default node;
